export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-[480px] aspect-[4/3] rounded-lg overflow-hidden bg-background-200 border border-background-300/40">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20modern%20cinema%20lobby%20interior%20with%20warm%20golden%20ambient%20lighting%2C%20abstract%20geometric%20wall%20panels%2C%20luxurious%20dark%20color%20palette%20with%20amber%20accent%20lights%2C%20sleek%20minimalist%20design%2C%20atmospheric%20depth%20with%20soft%20shadows%2C%20empty%20elegant%20space%20with%20cinematic%20mood%2C%20no%20text%20no%20people&width=960&height=720&seq=about-cinema-2026&orientation=landscape"
              alt="天堂影院 - 品牌介绍"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>

          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-400 bg-secondary-500/10 rounded-full mb-4">
              关于我们
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              天堂影院 — 你的在线观影伴侣
            </h2>
            <div className="mt-5 space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              <p>
                天堂影院是专注于免费在线影视播放的综合平台，致力于为影迷提供丰富、高清、流畅的观影体验。
                平台收录超过十万部电影、电视剧、综艺和动漫作品，涵盖动作、喜剧、悬疑、科幻、爱情等多种类型。
              </p>
              <p>
                我们坚持每日同步更新最新院线大片与热门剧集，所有资源均通过高速服务器分发，确保您在任何设备上都能享受流畅不缓冲的高清画质。
                无需注册登录，打开即看，让观影回归最简单的快乐。
              </p>
              <p>
                无论是追剧达人还是电影爱好者，天堂影院都是您探索影视世界的理想起点。我们持续优化播放体验与内容覆盖，
                努力成为最值得信赖的免费在线影院。
              </p>
            </div>

            <div className="mt-6 flex flex-wrap gap-3">
              {['10万+ 影视资源', '每日同步更新', '全高清画质', '无需注册'].map((stat) => (
                <span
                  key={stat}
                  className="px-3 py-1.5 text-xs font-medium text-foreground-600 bg-background-200 border border-background-300/40 rounded-md whitespace-nowrap"
                >
                  {stat}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}